import { Typography, Popconfirm } from 'antd';
import React from 'react';
import { FaEye, FaPencilAlt, FaRegTrashAlt, FaTimes } from 'react-icons/fa';
import Button from '~/components/Button';
import i18next from 'i18next';
import { formatPrice, parsePrice } from '~/Utils/format';
import FormControl from '~/components/Form/FormControl';
import { SelectAntd, SelectAntdFormik } from '~/components/Pagination/styles';
import InputCurrency from '~/components/Form/InputCurrency';
import Strong from '~/components/Strong';
import { TableActions } from '~/components/Table';
import Can from '~/components/Can';
import { Input, InputNumber } from 'formik-antd';
import InputTaged from '~/components/Form/InputTaged';

export const itemsColumns = (handleEdit, handleDelete, isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('screens:Nome')}:</Strong> {record?.name}
            <br />
            <Strong>{i18next.t('Peso Unitário (kg)')}:</Strong> {record?.weight}
            <br />
            <Strong>{i18next.t('Em estoque')}:</Strong> {record?.amount}
            <br />
            <TableActions align="center" justify="center" isMobile={isMobile}>
              <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
                <FaEye />
              </Button>
              <Can permission="@products/edit">
                <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
                  <FaPencilAlt />
                </Button>
              </Can>
              <Can permission="@products/delete">
                <Popconfirm
                  title={i18next.t('messages:confirmDelete')}
                  okText={i18next.t('messages:yes')}
                  onConfirm={() => handleDelete(record.id)}
                  cancelText={i18next.t('messages:no')}
                >
                  <Button size="small" title="Excluir">
                    <FaRegTrashAlt />
                  </Button>
                </Popconfirm>
              </Can>
            </TableActions>
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('screens:Nome'),
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => record.name,
    },
    {
      title: i18next.t('Peso Unitário (kg)'),
      dataIndex: 'weight',
      key: 'weight',
      render: (_, record) => record.weight,
    },
    {
      title: i18next.t('Em estoque'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: i18next.t('screens:default.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '140px',
      align: 'center',
      render: (_, record) => (
        <TableActions align="center" justify="center">
          <Button size="small" title="Visualizar" onClick={() => handleEdit(record, true)}>
            <FaEye />
          </Button>
          <Can permission="@products/edit">
            <Button size="small" title="Editar" onClick={() => handleEdit(record)}>
              <FaPencilAlt />
            </Button>
          </Can>
          <Can permission="@products/delete">
            <Popconfirm
              title={i18next.t('messages:confirmDelete')}
              okText={i18next.t('messages:yes')}
              onConfirm={() => handleDelete(record.id)}
              cancelText={i18next.t('messages:no')}
            >
              <Button size="small" title="Excluir">
                <FaRegTrashAlt />
              </Button>
            </Popconfirm>
          </Can>
        </TableActions>
      ),
    },
  ];
};

export const historyTable = (isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('Lote')}:</Strong> {record?.id}
            <br />
            <Strong>{i18next.t('Qtde em estoque')}:</Strong> {record?.amount}
            <br />
            <Strong>{i18next.t('Preço de custo')}:</Strong>{' '}
            {'R$ ' +
              parseFloat(record?.cost_price).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            <br />
            <Strong>{i18next.t('Fornecedor')}:</Strong> {record?.provider}
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('Lote'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: i18next.t('Qtde em estoque'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: i18next.t('Preço de custo'),
      dataIndex: 'cost_price',
      key: 'cost_price',
      render: (cost_price) =>
        'R$ ' + parseFloat(cost_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: i18next.t('Fornecedor'),
      dataIndex: 'provider',
      key: 'provider',
    },
  ];
};

export const lowStockHistoryTable = (isMobile) => {
  if (isMobile) {
    return [
      {
        dataIndex: 'summary',
        key: 'summary',
        render: (_, record) => (
          <div>
            <Strong>{i18next.t('Baixa')}:</Strong> {record?.id}
            <br />
            <Strong>{i18next.t('Qtde consumida')}:</Strong> {record?.amount}
            <br />
            <Strong>{i18next.t('Valor')}:</Strong>{' '}
            {'R$ ' +
              parseFloat(record?.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            <br />
            <Strong>{i18next.t('Evento')}:</Strong> {record?.event_name}
          </div>
        ),
      },
    ];
  }

  return [
    {
      title: i18next.t('Baixa'),
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: i18next.t('Qtde consumida'),
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: i18next.t('Valor'),
      dataIndex: 'price',
      key: 'price',
      render: (price) =>
        'R$ ' + parseFloat(price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    },
    {
      title: i18next.t('Evento'),
      dataIndex: 'event_name',
      key: 'event_name',
    },
  ];
};

export const itemsEventColumns = (items, errors, fluidPermissions, recalcConsigned) => {
  return [
    {
      title: i18next.t('fields:consigneds.item_id'),
      dataIndex: 'item_id',
      key: 'item_id',
      width: '25%',
      render: (_, record, index) => (
        <FormControl field={`consigneds.${index}.item_id`} error={errors?.consigneds?.[index]?.item_id} list required>
          <SelectAntdFormik
            name={`consigneds.${index}.item_id`}
            placeholder="SELECIONE"
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            disabled={!fluidPermissions()}
          >
            {items?.map((item) => (
              <SelectAntd.Option key={item.id} value={item.id}>
                {item.name}
              </SelectAntd.Option>
            ))}
          </SelectAntdFormik>
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:consigneds.amount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record, index) => (
        <FormControl field={`consigneds.${index}.amount`} error={errors?.consigneds?.[index]?.amount} list required>
          <InputNumber
            name={`consigneds.${index}.amount`}
            onBlur={(e) => {
              const value = e.target.value;
              recalcConsigned(index, 'amount', value);
            }}
            disabled={!fluidPermissions()}
            style={{ width: '100%' }}
          />
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:consigneds.packs'),
      dataIndex: 'packs',
      key: 'packs',
      render: (_, record, index) => (
        <FormControl field={`consigneds.${index}.packs`} error={errors?.consigneds?.[index]?.packs} list required>
          <Input
            name={`consigneds.${index}.packs`}
            onBlur={(e) => {
              const value = parsePrice(e.target.value);
              recalcConsigned(index, 'packs', value);
            }}
            disabled={!fluidPermissions()}
            style={{ width: '100%' }}
          />
        </FormControl>
      ),
    },
    {
      title: i18next.t('Peso total'),
      dataIndex: 'weight_total',
      key: 'weight_total',
      render: (_, record, index) => (
        <FormControl
          field={`consigneds.${index}.weight_total`}
          error={errors?.consigneds?.[index]?.weight_total}
          list
          required
        >
          <InputTaged>
            <Input name={`consigneds.${index}.weight_total`} disabled style={{ width: '100%' }} />
          </InputTaged>
        </FormControl>
      ),
    },
    {
      title: i18next.t('fields:consigneds.priceUnit'),
      dataIndex: 'price_unit',
      key: 'price_unit',
      render: (_, record, index) => (
        <FormControl
          field={`consigneds.${index}.price_unit`}
          error={errors?.consigneds?.[index]?.price_unit}
          list
          required
        >
          <InputCurrency
            name={`consigneds.${index}.price_unit`}
            disabled={!fluidPermissions()}
            style={{ width: '100%' }}
          />
        </FormControl>
      ),
    },
    {
      title: 'Total',
      dataIndex: 'price_total',
      key: 'price_total',
      width: '130px',
      render: (_, record) => {
        const total = parsePrice(record.price_unit ?? 0) * parsePrice(record.amount ?? 0);
        return <Typography.Text strong>{formatPrice(total)}</Typography.Text>;
      },
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Button
          color="primary"
          title="Remover item"
          size="small"
          style={{ width: '30px' }}
          onClick={() => record.remove(index)}
          disabled={!fluidPermissions()}
        >
          <FaTimes />
        </Button>
      ),
    },
  ];
};
